export enum HttpMethod {
    Get = 'GET' as any,
    Put = 'PUT' as any,
    Post = 'POST' as any,
    Push = 'PUSH' as any,
    Delete = 'DELETE' as any,
}